(function () {
  const modelContext = navigator.modelContext;

  if (!modelContext || typeof modelContext.registerTool !== 'function') {
    return;
  }

  const registeredControllers = [];
  const collectionHandles = [
    'neuheiten',
    'letzte-teile',
    'sale',
    'madchen-fashion',
    'jungen-fashion',
    'kindergroesse-62',
    'kindergroesse-68',
    'kindergroesse-74',
    'kindergroesse-80',
    'kindergroesse-86',
    'kindergroesse-92',
    'kindergroesse-98',
    'kindergroesse-104',
    'kindergroesse-110',
    'kindergroesse-116',
    'kindergroesse-122',
    'kindergroesse-128',
    'kindergroesse-134',
    'kindergroesse-140',
    'kindergroesse-146',
    'kindergroesse-152',
    'salt-pepper',
    'minymo',
    'mayoral',
    'sarabanda',
    'hust-claire',
    'name-it',
    'koko-noko',
    'danamade',
    'dirkje',
    'fliink',
    'hatley',
    'no-way-monday',
  ];
  const collectionAliases = {
    'maedchen-fashion': 'madchen-fashion',
  };
  const collectionOptions = collectionHandles.concat(Object.keys(collectionAliases));
  const sortOptions = ['manual', 'best-selling', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending', 'created-ascending', 'created-descending'];

  function registerTool(tool) {
    const controller = new AbortController();

    try {
      modelContext.registerTool(tool, { signal: controller.signal });
      registeredControllers.push(controller);
    } catch (error) {
      if (window.console && typeof window.console.warn === 'function') {
        window.console.warn('Mokkini WebMCP tool registration failed:', tool.name, error);
      }
    }
  }

  function routeFor(path) {
    return new URL(path, window.location.origin).toString();
  }

  function cleanQuery(query) {
    return String(query || '').trim().slice(0, 120);
  }

  function cleanLabel(value) {
    return String(value || '')
      .trim()
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function getVariantGroupName(group) {
    const legend = group.querySelector('legend');

    if (legend) {
      const legendClone = legend.cloneNode(true);
      legendClone.querySelector('[data-selected-value]')?.remove();
      return legendClone.textContent.replace(':', '').trim();
    }

    return group.querySelector('label')?.textContent?.trim() || '';
  }

  function getPageType() {
    const path = window.location.pathname;

    if (getCurrentProductForm()) return 'product';
    if (path.startsWith('/collections/')) return 'collection';
    if (path.startsWith('/search')) return 'search';
    if (path.startsWith('/cart')) return 'cart';
    if (path === '/' || path === '') return 'home';

    return 'page';
  }

  function getMetaContent(selector) {
    return document.querySelector(selector)?.getAttribute('content') || '';
  }

  function getPageContext() {
    const productForm = getCurrentProductForm();
    const selectedOptions = [];

    document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown').forEach((group) => {
      const optionName = getVariantGroupName(group);
      const selectedInput = group.querySelector('input[type="radio"]:checked');
      const selectedSelect = group.querySelector('select');
      const selectedValue = selectedInput?.value || selectedSelect?.value || '';

      if (optionName && selectedValue) {
        selectedOptions.push({ name: optionName, value: selectedValue });
      }
    });

    return {
      pageType: getPageType(),
      title: document.title,
      url: window.location.href,
      canonicalUrl: document.querySelector('link[rel="canonical"]')?.href || window.location.href,
      description: getMetaContent('meta[name="description"]'),
      product: productForm
        ? {
            title: document.querySelector('.product__title h1')?.textContent?.trim() || getMetaContent('meta[property="og:title"]'),
            variantId: getCurrentVariantId(),
            selectedOptions,
            price: document.querySelector('[id^="price-"] .price-item--regular')?.textContent?.trim() || '',
            available: !productForm.querySelector('[type="submit"]')?.disabled,
          }
        : null,
    };
  }

  function getCurrentProductForm() {
    return document.querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function getCurrentVariantId() {
    const form = getCurrentProductForm();
    return form ? form.querySelector('[name="id"]')?.value : '';
  }

  function getCurrentQuantity(quantity) {
    const parsedQuantity = Number.parseInt(quantity, 10);
    if (Number.isFinite(parsedQuantity) && parsedQuantity > 0) {
      return Math.min(parsedQuantity, 10);
    }

    const form = getCurrentProductForm();
    const formQuantity = form ? Number.parseInt(form.querySelector('[name="quantity"]')?.value, 10) : 1;

    return Number.isFinite(formQuantity) && formQuantity > 0 ? Math.min(formQuantity, 10) : 1;
  }

  async function fetchJson(url, options) {
    const response = await fetch(url, options);
    let payload;

    try {
      payload = await response.json();
    } catch (error) {
      throw new Error('Die Antwort konnte nicht als JSON gelesen werden.');
    }

    if (!response.ok || payload.status) {
      throw new Error(payload.description || payload.message || 'Die Anfrage konnte nicht verarbeitet werden.');
    }

    return payload;
  }

  async function getCart() {
    return fetchJson(routeFor('/cart.js'), {
      headers: {
        Accept: 'application/json',
      },
    });
  }

  async function addVariantToCart(variantId, quantity) {
    const cartDrawer = document.querySelector('cart-drawer');
    const formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', String(quantity));

    if (cartDrawer) {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
    }

    const payload = await fetchJson(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    if (cartDrawer) {
      cartDrawer.renderContents(payload);
    }

    return payload;
  }

  function findVariantControl(optionName, value) {
    const normalizedOptionName = cleanLabel(optionName);
    const normalizedValue = cleanLabel(value);

    if (!normalizedOptionName || !normalizedValue) {
      return null;
    }

    const groups = document.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input--dropdown');

    for (const group of groups) {
      const groupName = getVariantGroupName(group);

      if (cleanLabel(groupName) !== normalizedOptionName) {
        continue;
      }

      const select = group.querySelector('select');
      if (select) {
        const option = Array.from(select.options).find((item) => cleanLabel(item.value || item.textContent) === normalizedValue);
        return option ? { type: 'select', select, option } : null;
      }

      const input = Array.from(group.querySelectorAll('input[type="radio"]')).find(
        (item) => cleanLabel(item.value) === normalizedValue && !item.disabled
      );

      return input ? { type: 'radio', input } : null;
    }

    return null;
  }

  function productCards(limit) {
    return Array.from(document.querySelectorAll('.product-card-wrapper .card__heading a'))
      .slice(0, limit)
      .map((link) => ({
        title: link.textContent.trim(),
        url: new URL(link.getAttribute('href'), window.location.origin).toString(),
      }));
  }

  function navigateWithParams(paramsToSet, paramsToDelete) {
    const url = new URL(window.location.href);

    paramsToDelete.forEach((name) => url.searchParams.delete(name));
    Object.entries(paramsToSet).forEach(([name, value]) => {
      if (value === '' || value === null || value === undefined) {
        url.searchParams.delete(name);
      } else {
        url.searchParams.set(name, value);
      }
    });

    window.location.assign(url.toString());
  }

  registerTool({
    name: 'mokkini_get_page_context',
    description:
      'Return the current visible Mokkini page context, including page type, URL, title, and selected product variant details when on a product page.',
    inputSchema: {
      type: 'object',
      properties: {},
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async () => JSON.stringify(getPageContext()),
  });

  registerTool({
    name: 'mokkini_search_products',
    description:
      'Search Mokkini products by keyword, brand, size, color, category, or article name. Navigates to the visible search results page.',
    inputSchema: {
      type: 'object',
      properties: {
        query: {
          type: 'string',
          description: 'Search term such as a brand, product type, size, color, or article name.',
        },
      },
      required: ['query'],
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async ({ query } = {}) => {
      const term = cleanQuery(query);

      if (!term) {
        return 'Bitte gib einen Suchbegriff an.';
      }

      const params = new URLSearchParams({
        q: term,
        'options[prefix]': 'last',
      });

      window.location.assign(routeFor(`/search?${params.toString()}`));
      return null;
    },
  });

  registerTool({
    name: 'mokkini_open_key_page',
    description: 'Navigate to a key Mokkini page such as the home page, brand directory, guides, contact page, or cart.',
    inputSchema: {
      type: 'object',
      properties: {
        page: {
          type: 'string',
          enum: ['home', 'brands', 'guides', 'contact', 'cart'],
          description: 'Key page to open.',
        },
      },
      required: ['page'],
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async ({ page } = {}) => {
      const pages = {
        home: '/',
        brands: '/collections',
        guides: '/pages/unsere-ratgeber',
        contact: '/pages/contact',
        cart: window.routes.cart_url,
      };

      if (!pages[page]) {
        return 'Diese Seite ist nicht als WebMCP-Navigation hinterlegt.';
      }

      window.location.assign(routeFor(pages[page]));
      return null;
    },
  });

  registerTool({
    name: 'mokkini_browse_collection',
    description:
      'Navigate to an important Mokkini collection such as new arrivals, last chance, gender, size, or brand collections.',
    inputSchema: {
      type: 'object',
      properties: {
        collection: {
          type: 'string',
          enum: collectionOptions,
          description: 'Collection handle to open.',
        },
      },
      required: ['collection'],
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async ({ collection }) => {
      if (!collectionOptions.includes(collection)) {
        return 'Diese Collection ist nicht als WebMCP-Navigation hinterlegt.';
      }

      const collectionHandle = collectionAliases[collection] || collection;
      window.location.assign(routeFor(`/collections/${collectionHandle}`));
      return null;
    },
  });

  registerTool({
    name: 'mokkini_list_visible_products',
    description: 'List visible product cards on the current Mokkini collection or search results page.',
    inputSchema: {
      type: 'object',
      properties: {
        limit: {
          type: 'integer',
          minimum: 1,
          maximum: 12,
          description: 'Maximum number of visible product cards to return.',
        },
      },
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async ({ limit } = {}) => {
      const count = Math.min(Math.max(Number.parseInt(limit, 10) || 6, 1), 12);
      return JSON.stringify(productCards(count));
    },
  });

  registerTool({
    name: 'mokkini_sort_products',
    description: 'Sort the current Mokkini collection or search results page by a supported Shopify sort option.',
    inputSchema: {
      type: 'object',
      properties: {
        sortBy: {
          type: 'string',
          enum: sortOptions,
          description: 'Shopify sort option.',
        },
      },
      required: ['sortBy'],
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async ({ sortBy } = {}) => {
      if (!sortOptions.includes(sortBy)) {
        return 'Diese Sortierung wird nicht unterstuetzt.';
      }

      if (!['collection', 'search'].includes(getPageType())) {
        return 'Sortieren ist nur auf Collection- oder Suchergebnisseiten sinnvoll.';
      }

      navigateWithParams({ sort_by: sortBy }, []);
      return null;
    },
  });

  registerTool({
    name: 'mokkini_clear_filters',
    description: 'Clear current Shopify collection or search filters while preserving the search query when present.',
    inputSchema: {
      type: 'object',
      properties: {},
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async () => {
      if (!['collection', 'search'].includes(getPageType())) {
        return 'Filter koennen nur auf Collection- oder Suchergebnisseiten geloescht werden.';
      }

      const url = new URL(window.location.href);
      const preservedQuery = url.searchParams.get('q');
      const preservedPrefix = url.searchParams.get('options[prefix]');

      url.search = '';

      if (preservedQuery) {
        url.searchParams.set('q', preservedQuery);
      }
      if (preservedPrefix) {
        url.searchParams.set('options[prefix]', preservedPrefix);
      }

      window.location.assign(url.toString());
      return null;
    },
  });

  registerTool({
    name: 'mokkini_open_cart',
    description: 'Open the visible Mokkini cart drawer if available, otherwise navigate to the cart page.',
    inputSchema: {
      type: 'object',
      properties: {},
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async () => {
      const cartDrawer = document.querySelector('cart-drawer');

      if (cartDrawer && typeof cartDrawer.open === 'function') {
        cartDrawer.open(document.querySelector('#cart-icon-bubble') || document.activeElement);
        return 'Warenkorb geoeffnet.';
      }

      window.location.assign(routeFor(window.routes.cart_url));
      return null;
    },
  });

  registerTool({
    name: 'mokkini_get_cart_summary',
    description: 'Return the current Mokkini cart item count, subtotal, and visible line items.',
    inputSchema: {
      type: 'object',
      properties: {},
    },
    annotations: {
      readOnlyHint: true,
      untrustedContentHint: false,
    },
    execute: async () => {
      const cart = await getCart();

      return JSON.stringify({
        itemCount: cart.item_count,
        totalPrice: cart.total_price,
        currency: cart.currency || 'EUR',
        items: cart.items.map((item, index) => ({
          line: index + 1,
          title: item.product_title,
          variant: item.variant_title,
          quantity: item.quantity,
          price: item.final_line_price,
          url: item.url,
        })),
      });
    },
  });

  if (getCurrentProductForm()) {
    registerTool({
      name: 'mokkini_select_product_option',
      description:
        'Select a visible option on the current Mokkini product page, such as size or color. Use before adding the product to cart.',
      inputSchema: {
        type: 'object',
        properties: {
          option: {
            type: 'string',
            description: 'Visible option name, for example Groesse, Farbe, Size, or Color.',
          },
          value: {
            type: 'string',
            description: 'Visible option value to select, for example 104, 116, Rosa, or Blau.',
          },
        },
        required: ['option', 'value'],
      },
      annotations: {
        readOnlyHint: false,
        untrustedContentHint: false,
      },
      execute: async ({ option, value }) => {
        const control = findVariantControl(option, value);

        if (!control) {
          return `Option ${option} mit Wert ${value} wurde auf dieser Produktseite nicht gefunden.`;
        }

        if (control.type === 'select') {
          control.select.value = control.option.value;
          control.select.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          control.input.click();
          control.input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        return `Produktoption ${option} wurde auf ${value} gesetzt.`;
      },
    });

    registerTool({
      name: 'mokkini_add_current_product_to_cart',
      description:
        'Add the currently selected product variant on this Mokkini product page to the cart. This does not start checkout or complete a purchase.',
      inputSchema: {
        type: 'object',
        properties: {
          quantity: {
            type: 'integer',
            minimum: 1,
            maximum: 10,
            description: 'Quantity to add. Defaults to the visible product quantity or 1.',
          },
        },
      },
      annotations: {
        readOnlyHint: false,
        untrustedContentHint: false,
      },
      execute: async ({ quantity } = {}) => {
        const productForm = getCurrentProductForm();
        const variantId = getCurrentVariantId();

        if (!variantId) {
          return 'Auf dieser Seite ist keine kaufbare Produktvariante ausgewaehlt.';
        }

        if (productForm?.querySelector('[type="submit"]')?.disabled) {
          return 'Die aktuell ausgewaehlte Variante ist nicht verfuegbar und wurde nicht in den Warenkorb gelegt.';
        }

        const addedQuantity = getCurrentQuantity(quantity);
        const payload = await addVariantToCart(variantId, addedQuantity);
        const title = payload.product_title || 'Produkt';

        return `${addedQuantity} x ${title} wurde in den Warenkorb gelegt.`;
      },
    });
  }

  window.addEventListener('pagehide', (event) => {
    if (event.persisted) {
      return;
    }

    registeredControllers.forEach((controller) => controller.abort());
  });
})();
